export const axiosErrors = {
    TIMEOUT_AXIOS_ERROR_CODE: 'ECONNABORTED',
};
